import Vue from "vue";

export function getToken() {
  try {
    return localStorage.getItem("nutricao-animal-usuario-token");
  } catch (error) {
    return null;
  }
}

export function formatMoeda(value, numDec = 2) {
  try {
    return value.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: numDec,
    });
  } catch (error) {
    return 0;
  }
}

export function formatPercentual(value, numDec = 2) {
  try {
    return Number(value / 100).toLocaleString("pt-br", {
      style: "percent",
      minimumFractionDigits: numDec,
    });
  } catch (error) {
    return 0;
  }
}

export function formatarNumeroDec(value) {
  try {
    if (value.trim() == "") {
      return 0;
    }
    if (value.includes(",")) return value.replace(",", ".");

    return value;
  } catch (error) {
    return 0;
  }
}

export function getUrlRelatorio() {
  return process.env.NODE_ENV == "development"
    ? "http://192.168.1.187/app/impressao"
    : "https://www.coasul.com.br/nutricao-animal/impressao";
}

export function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// helper na própria store (fora do export default)
export function isMobileMq() {
  // se VueMq estiver disponível no prototype (componentes já registraram o plugin)
  if (Vue.prototype && Vue.prototype.$mq) {
    return Vue.prototype.$mq === "sm";
  }
  // fallback: usa os breakpoints que você registrou no VueMq (sm: 450)
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(max-width: 450px)").matches;
  }
  return false;
}

export function base64ToBlobUrl(base64, mimeType) {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: mimeType });
  return URL.createObjectURL(blob);
}

// utils/comprimirImagem.js

export async function comprimirImagem(file, maxWidth = 1600, maxHeight = 1600, quality = 0.8) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const img = new Image();

    reader.onload = (e) => {
      img.onload = () => {
        let { width, height } = img;

        // Redimensiona mantendo proporção
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = width * ratio;
          height = height * ratio;
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error("Falha ao comprimir imagem"));
            resolve(blob);
          },
          "image/jpeg",
          quality
        );
      };

      img.onerror = reject;
      img.src = e.target.result;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}



export default {
  getToken,
  formatMoeda,
  formatPercentual,
  formatarNumeroDec,
  toBase64,
  isMobileMq,
  base64ToBlobUrl,
  comprimirImagem
};
